// extracted by mini-css-extract-plugin
export default {"confirmModal":"GroupInfoModal_confirmModal__2od+a"};